module.exports = __webpack_public_path__ + "static/media/wpLogo.ccf1c5e7.png";